import SuccessSpinner from './SuccessSpinner'

export default SuccessSpinner
